import { createTheme } from '@mui/material/styles';

/**
 * Paleta MUI sincronizada con los tokens semánticos de
 * `client/src/theme/tokens.css`. Mantener ambos en sync si cambian
 * los colores: el bloque `:root` (light) y `:root[data-theme="dark"]`
 * de tokens.css son la fuente de verdad para CSS, y este objeto es
 * la fuente para MUI. Los valores numéricos aquí DEBEN coincidir con
 * los de tokens.css.
 *
 * No usamos `cssVariables: true` de MUI v6 — los tokens ya están en
 * CSS custom properties, y mantener dos sistemas duplicaría estado.
 * El switch entre light/dark se hace leyendo `mode` desde useColorMode
 * y pasando el resultado a <ThemeProvider theme={createAppTheme(mode)}>.
 */
const PALETTES = {
  light: {
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    success: '#15be53',
    warning: '#f59e0b',
    info: '#2563eb',
    danger: '#ea2261',
    bgPage: '#f7f9fc',
    bgCard: '#ffffff',
    bgSoft: '#eff6ff',
    textTitle: '#061b31',
    textBody: '#273951',
    textMuted: '#64748d',
    border: '#e5edf5',
  },
  dark: {
    primary: '#3b82f6',
    primaryHover: '#60a5fa',
    success: '#34d97a',
    warning: '#fbbf24',
    info: '#3b82f6',
    danger: '#f43f75',
    bgPage: '#0f1419',
    bgCard: '#1a1f2e',
    bgSoft: '#0e223d',
    textTitle: '#f1f5f9',
    textBody: '#c4cad4',
    textMuted: '#8b95a5',
    border: '#2a3242',
  },
};

export default function createAppTheme(mode = 'light') {
  const c = PALETTES[mode] || PALETTES.light;

  return createTheme({
    palette: {
      mode,
      primary: { main: c.primary, dark: c.primaryHover, contrastText: '#ffffff' },
      success: { main: c.success },
      warning: { main: c.warning },
      info: { main: c.info },
      error: { main: c.danger },
      background: {
        default: c.bgPage,
        paper: c.bgCard,
      },
      text: {
        primary: c.textTitle,
        secondary: c.textBody,
        disabled: c.textMuted,
      },
      divider: c.border,
    },
    typography: {
      fontFamily:
        "'sohne-var', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
      fontFeatureSettings: '"ss01"',
    },
    shape: {
      borderRadius: 6,
    },
  });
}
